import { Link } from "react-router-dom";
import styled from "styled-components";
import data from "../data/products.json";
import images from "../assets/products";
import Reveal from "./Reveal";

export default function ProductGrid({ exclude }) {
  const list = data.products.filter((p) => p.slug !== exclude);

  return (
    <Grid>
      {list.map((p, i) => (
        <Reveal key={p.slug} delay={(i % 4) * 0.07}>
          <CardLink to={`/produktet/${p.slug}`} $accent={p.accent}>
            <Media style={{ background: p.accentSoft }}>
              <img src={images[p.slug]} alt={`Aroma Stick ${p.name}`} />
            </Media>
            <Body>
              <Name>{p.name}</Name>
              <Sub>{p.emri}</Sub>
              <Tag>{p.tagline}</Tag>
              <More>
                Lexo më shumë
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14M13 6l6 6-6 6" />
                </svg>
              </More>
            </Body>
          </CardLink>
        </Reveal>
      ))}
    </Grid>
  );
}

const Grid = styled.div`
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(2, 1fr);

  ${({ theme }) => theme.bp.sm} {
    gap: 24px;
    grid-template-columns: repeat(3, 1fr);
  }
  ${({ theme }) => theme.bp.lg} {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const CardLink = styled(Link)`
  display: block;
  height: 100%;
  border-radius: ${({ theme }) => theme.radius.lg};
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface};
  border: 1px solid ${({ theme }) => theme.colors.line};
  transition: transform 0.5s ${({ theme }) => theme.ease},
    box-shadow 0.5s ease, border-color 0.4s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: ${({ theme }) => theme.shadow.lift};
    border-color: ${({ $accent }) => $accent};
  }

  &:hover img {
    transform: translateY(-8px) scale(1.05) rotate(-2deg);
  }
`;

const Media = styled.div`
  aspect-ratio: 1 / 1;
  display: grid;
  place-items: center;
  padding: 16%;
  transition: background 0.5s ease;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: drop-shadow(0 14px 22px rgba(28, 27, 24, 0.2));
    transition: transform 0.6s ${({ theme }) => theme.ease};
  }
`;

const Body = styled.div`
  padding: 18px 18px 22px;

  ${({ theme }) => theme.bp.sm} {
    padding: 22px 22px 26px;
  }
`;

const Name = styled.h3`
  font-size: ${({ theme }) => theme.size.xl};
  line-height: 1;
`;

const Sub = styled.span`
  display: block;
  font-size: ${({ theme }) => theme.size.xs};
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: ${({ theme }) => theme.colors.inkFaint};
  margin-top: 7px;
`;

const Tag = styled.p`
  margin-top: 12px;
  font-size: ${({ theme }) => theme.size.sm};
  color: ${({ theme }) => theme.colors.inkSoft};
  line-height: 1.5;
`;

const More = styled.span`
  margin-top: 16px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  font-size: ${({ theme }) => theme.size.sm};
  font-weight: 500;

  svg {
    transition: transform 0.4s ${({ theme }) => theme.ease};
  }

  ${CardLink}:hover & svg {
    transform: translateX(4px);
  }
`;
